'use strict';
import * as $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fbutton$002fbutton$002ejs from "@awesome.me/webawesome/dist/components/button/button.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent from "./io.github.nguyenyou.webawesome.laminar.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_Button$() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
  $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__(this, "wa-button");
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_Button$ as $c_Lio_github_nguyenyou_webawesome_laminar_Button$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_Button$.prototype = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_Button$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_Button$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_Button$ as $h_Lio_github_nguyenyou_webawesome_laminar_Button$ };
$h_Lio_github_nguyenyou_webawesome_laminar_Button$.prototype = $p;
$p.cQ = (function() {
  return $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fbutton$002fbutton$002ejs;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_Button$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_Button$, "io.github.nguyenyou.webawesome.laminar.Button$", ({
  jO: 1,
  bp: 1,
  bo: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_Button$ as $d_Lio_github_nguyenyou_webawesome_laminar_Button$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_Button$;
function $m_Lio_github_nguyenyou_webawesome_laminar_Button$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_Button$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_Button$ = new $c_Lio_github_nguyenyou_webawesome_laminar_Button$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_Button$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_Button$ as $m_Lio_github_nguyenyou_webawesome_laminar_Button$ };
